import { useTheme, Theme } from '@mui/material/styles';
import { withStyles } from 'tss-react/mui';
import Modal from '@mui/material/Modal';
import classNames from 'classnames';
import { CommonPropsAndTypes } from '../_Types/StandardComponentProps';
import { EDNavigationOverlayPaper } from './Components/EDFNavigationOverlayPaper';
import {
  APP_HEADER_TOTAL_HEIGHT_PX,
  APP_NAVBAR_HEIGHT_PX,
} from '../ThemeProvider/AvenyTheme';
import { useIsFloatingMenuVisible } from '../../Components/FloatingBottomArea/FloatingMenu';

interface IProps extends CommonPropsAndTypes.IPaddingProps {
  children: React.ReactNode;
  open: boolean;
  onClose?: (event: object, reason: string) => void;
  disableEscapeKeyDown?: boolean;
  classes?: Partial<Record<keyof ReturnType<typeof styles>, string>>;
  className?: string;
  keepMounted?: boolean;
}

const styles = (theme: Theme) => ({
  /** Style applied to the root element */
  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'stretch',
    padding: theme.spacing(0),
  },
});

const EDNavigationOverlayBase = (props: IProps) => {
  const classes = withStyles.getClasses(props);
  const { modal } = classes;
  const theme = useTheme();
  const floatingTouchLayout = useIsFloatingMenuVisible();

  const handleClose = (event: object, reason: string): void => {
    if (props.onClose && reason !== 'backdropClick') {
      props.onClose(event, reason);
    }
  };

  const height = floatingTouchLayout
    ? APP_NAVBAR_HEIGHT_PX
    : APP_HEADER_TOTAL_HEIGHT_PX;

  return (
    <Modal
      className={classNames(modal, props.className)}
      disableEscapeKeyDown={props.disableEscapeKeyDown}
      open={props.open}
      onClose={handleClose}
      style={{
        // TODO: FFS: MUI är korkade nog att sätta de tidigare klass-stilarna direkt på style, så vi måste göra likadant...
        zIndex: theme.zIndex.fab - 1,
        top: height,
        height: `calc(100% - ${height}px)`,
      }}
      disableEnforceFocus
      disableAutoFocus
      hideBackdrop
      keepMounted={props.keepMounted}
    >
      <EDNavigationOverlayPaper>{props.children}</EDNavigationOverlayPaper>
    </Modal>
  );
};

export const EDNavigationOverlay = withStyles(EDNavigationOverlayBase, styles);
